<template>
    <v-container class="ma-0 pa-0 pb-8">
        <v-row class="pt-10 px-8 pb-12">
            <strong>Filtros</strong>
            <v-spacer></v-spacer>
            <v-btn @click="removeFilter()" small class="elevation-0" style="border:solid 1px #dddddd;">
                <v-icon small class="mr-1">mdi-filter-off</v-icon>Limpiar
            </v-btn>
            <v-menu offset-y :close-on-content-click="closeDatePicker(collection_status.deadline_date)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable v-model="collection_status.deadline_date" label="Fecha Cierre" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="collection_status.deadline_date" range></v-date-picker>
            </v-menu>
            <!--v-menu offset-y :close-on-content-click="closeDatePicker(collection_status.promise_date)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable v-model="collection_status.promise_date" label="Fecha Promesa" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="collection_status.promise_date" range></v-date-picker>
            </v-menu-->
            <v-menu offset-y :close-on-content-click="closeDatePicker(collection_status.pay_date)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable v-model="collection_status.pay_date" label="Fecha Pago" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="collection_status.pay_date" range></v-date-picker>
            </v-menu>
            <v-menu offset-y :close-on-content-click="closeDatePicker(collection_status.invoice_date)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable v-model="collection_status.invoice_date" label="Fecha Factura" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="collection_status.invoice_date" range></v-date-picker>
            </v-menu>
            <v-menu offset-y :close-on-content-click="closeDatePicker(collection_status.influencer_payment_date)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable v-model="collection_status.influencer_payment_date" label="Fecha Pago Influencer" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="collection_status.influencer_payment_date" range></v-date-picker>
            </v-menu>
            <v-menu offset-y :close-on-content-click="closeDatePicker(collection_status.created_between)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable v-model="collection_status.created_between" label="Fecha de Creación" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="collection_status.created_between" range></v-date-picker>
            </v-menu>
        </v-row>
        <v-card style="position:absolute; bottom:0; width:100%;" tile color="primary">
            <v-list-item link @click="filter()" dark>
                <v-list-item-content>
                    <strong>Filtrar (0)</strong>
                </v-list-item-content>
            </v-list-item>    
        </v-card>
    </v-container>
</template>

<script>
import axios from "axios"
export default {
    data: () => ({
        collection_status:{
            influencer_payment_date:[],
            invoice_date:[],
            promise_date:[],
            deadline_date:[],
            pay_date:[],
            created_between:[],
        }
    }),
    created(){
        if(localStorage.getItem('selectorFiltersCollectionStatus')!=undefined){
            this.collection_status = JSON.parse(localStorage.getItem('selectorFiltersCollectionStatus'))
        }
    },
    methods:{
        closeDatePicker(dates){
            if(dates!=null && dates.length==2){
                return true
            }else{
                return false
            }
        },
        removeFilter(){
            this.collection_status={
                influencer_payment_date:[],
                invoice_date:[],
                promise_date:[],
                deadline_date:[],
                pay_date:[],
                created_between:[],
            },
            this.$nextTick(() => {
                this.$emit("filtersCollectionStatus", this.collection_status);
            })
            localStorage.removeItem("selectorFiltersCollectionStatus")
            localStorage.removeItem("filtersCollectionStatus")
            localStorage.removeItem("entriesFiltersCollectionStatus")
            localStorage.removeItem("filtersCollectionStatusLength")
            this.$nextTick(() => {
                this.$emit("filtersSale", false);
            })
        },
        filter(){
            var count = 0
            var filter = ''
            //date
            if(this.collection_status.deadline_date.length==2){
                count = count+1
                filter = filter + '&filter[deadline_date_between]=' + this.collection_status.deadline_date[0] + ',' + this.collection_status.deadline_date[1]
            }
            if(this.collection_status.influencer_payment_date.length==2){
                count = count+1
                filter = filter + '&filter[influencer_pay_date_between]=' + this.collection_status.influencer_payment_date[0] + ',' + this.collection_status.influencer_payment_date[1]
            }
            if(this.collection_status.invoice_date.length==2){
                count = count+1
                filter = filter + '&filter[invoice_date_between]=' + this.collection_status.invoice_date[0] + ',' + this.collection_status.invoice_date[1]
            }
            if(this.collection_status.promise_date.length==2){
                count = count+1
                filter = filter + '&filter[promise_date_between]=' + this.collection_status.promise_date[0] + ',' + this.collection_status.promise_date[1]
            }
            if(this.collection_status.pay_date.length==2){
                count = count+1
                filter = filter + '&filter[pay_date_between]=' + this.collection_status.pay_date[0] + ',' + this.collection_status.pay_date[1]
            }
            if(this.collection_status.created_between.length==2){
                count = count+1
                filter = filter + '&filter[created_between]=' + this.collection_status.created_between[0] + ',' + this.collection_status.created_between[1]
            }
            //save
            localStorage.setItem('selectorFiltersCollectionStatus', JSON.stringify(this.collection_status));
            localStorage.setItem('filtersCollectionStatus', JSON.stringify(filter.slice(1,filter.length)));
            localStorage.setItem('filtersCollectionStatusLength', count)

            this.$nextTick(() => {
                this.$emit("filtersCollectionStatus", false);
            })
        }
    }
}
</script>



